import React, { useEffect, useState } from "react";
import Layout from "./Layout";
import { useNavigate, useParams } from "react-router-dom";
import axios, { cookies } from "../../axios/axios";

const WeddingAlbumDetailManager = () => {
  const [weddingAlbum, setWeddingAlbum] = useState({});
  const [status, setStatus] = useState(1);
  const [editors, setEditors] = useState([]); // List of editors
  const [selectedEditor, setSelectedEditor] = useState(""); // Selected editor
  const [fileLocation, setFileLocation] = useState("");
  const [errorMessage, seterrorMessage] = useState("");
  const [message, setMessage] = useState("");

  const { id } = useParams();
  const navigate = useNavigate();

  const getWeddingAlbumById = async () => {
    try {
      const response = await axios.get(`/wedding-album/${id}`);
      setWeddingAlbum(response.data);
      setStatus(response.data.status || 1);
      setSelectedEditor(response.data.editor || ""); // Set selected editor from fetched data
      setFileLocation(response.data.fileLocation || "");
      setStatus(response.data.status || 1); // Set status from fetched data
    } catch (error) {
      console.log(error);
    }
  };

  const getEditors = async () => {
    try {
      const response = await axios.get("/user/allUsers");
      const editorUsers = response.data.filter(
        (user) => user.role === "editor"
      );
      setEditors(editorUsers);
    } catch (error) {
      console.error("Error fetching editors:", error);
    }
  };

  useEffect(() => {
    getWeddingAlbumById();
    getEditors();
  }, []);

  const updateWeddingAlbum = async () => {
    try {
      await axios.put(`/wedding-album/${id}`, {
        status,
        editor: userRole === "editor" ? userName : selectedEditor,
        fileLocation,
        message,
      });
      navigate("/weddingalbum-manager");
    } catch (error) {
      console.log(error);
      seterrorMessage(error.response?.data?.message || "An error occurred");
    }
  };

  const user = cookies.get("user");
  const userRole = user?.user?.role;
  const userName = user?.user?.fname;

  return (
    <Layout>
      <div className="container mt-4">
        {errorMessage && (
          <div
            class="alert alert-danger alert-dismissible fade show"
            role="alert"
          >
            {errorMessage}
            <button
              type="button"
              class="btn-close shadow-none"
              data-bs-dismiss="alert"
              aria-label="Close"
            ></button>
          </div>
        )}
        <div className="row">
          {/* Left Panel */}
          <div className="col-md-6">
            <div className="card mb-3">
              <div className="card-header fw-600">Job Details</div>
              <div className="card-body">
                <p>
                  <strong>Event Name:</strong> {weddingAlbum.order_name}
                </p>
                <p>
                  <strong>Service Type:</strong>{" "}
                  {weddingAlbum.serviceId?.service}
                </p>
                <p>
                  <strong>Album Type:</strong> {weddingAlbum.order_name}
                </p>
              </div>
            </div>{" "}
            <div className="card mb-3">
              <div className="card-header fw-600">Job Details</div>
              <div className="card-body">
                <p>
                  <strong>Album Orientation :</strong>{" "}
                  {weddingAlbum.album_orientation}
                </p>
                <p>
                  <strong>Album Category :</strong>{" "}
                  {weddingAlbum.album_category}
                </p>
                <p>
                  <strong>Page Size (width x height) :</strong>{" "}
                  {weddingAlbum.page_size}
                </p>
                <p>
                  <strong>Album Style :</strong> {weddingAlbum.album_style}
                </p>
                <p>
                  <strong>Front Cover Required :</strong>{" "}
                  {weddingAlbum.front_cover}
                </p>
                <p>
                  <strong>Back Cover Required :</strong>{" "}
                  {weddingAlbum.back_cover}
                </p>
                <p>
                  <strong>Background Color :</strong>{" "}
                  {weddingAlbum.background_color}
                </p>
                <p>
                  <strong>First page starts on :</strong>{" "}
                  {weddingAlbum.first_frame}
                </p>{" "}
                <p>
                  <strong>Name of Front Image File :</strong>{" "}
                  {weddingAlbum.front_image_name}
                </p>
                <p>
                  <strong>Front Cover Text - Line 1 :</strong>{" "}
                  {weddingAlbum.front_cover_text_line1}
                </p>
                <p>
                  <strong>Front Cover Text - Line 2 :</strong>{" "}
                  {weddingAlbum.front_cover_text_line2}
                </p>
                <p>
                  <strong>Name of Back Image File :</strong>{" "}
                  {weddingAlbum.back_image_name}
                </p>{" "}
                <p>
                  <strong>Back Cover Text - Line 1 :</strong>{" "}
                  {weddingAlbum.back_cover_text_line1}
                </p>{" "}
                <p>
                  <strong>Back Cover Text - Line 2 :</strong>{" "}
                  {weddingAlbum.back_cover_text_line2}
                </p>{" "}
                <p>
                  <strong>Cover Spine Text :</strong>{" "}
                  {weddingAlbum.cover_spine_text}
                </p>{" "}
                <p>
                  <strong>Font Options :</strong> {weddingAlbum.font_options}
                </p>{" "}
                <p>
                  <strong>Output Format :</strong> {weddingAlbum.output_format}
                </p>
                <p>
                  <strong>Quantity :</strong> {weddingAlbum.quantity}
                </p>
                <p>
                  <strong>Social media :</strong> {weddingAlbum.social_media}
                </p>{" "}
                <p>
                  <strong>Link :</strong> {weddingAlbum.drive_link}
                </p>{" "}
                <p>
                  <strong>Upload:</strong> {weddingAlbum.images}
                </p>
                <p>
                  <strong>Aditional notes :</strong>{" "}
                  {weddingAlbum.additional_notes}
                </p>
              </div>
            </div>
          </div>

          {/* Right Panel */}
          <div className="col-md-6">
            <div className="card mb-3">
              <div className="card-header fw-600">Order Operations</div>
              <div className="card-body">
                <p>
                  <strong>Client ID:</strong> {weddingAlbum.userId?.id}
                </p>
                <p>
                  <strong>Order ID:</strong> {weddingAlbum.id}
                </p>
                <p>
                  <strong>User Feedback:</strong> {weddingAlbum.sampleFeedback}
                </p>
                <p>
                  <strong>Order Place Date:</strong>{" "}
                  {new Date(weddingAlbum.createdAt).toLocaleDateString()}
                </p>

                <label className="form-label">Order Status</label>
                <select
                  className="form-select"
                  value={status}
                  onChange={(e) => setStatus(Number(e.target.value))}
                >
                  <option value={1}>New Order</option>
                  <option value={2}>In Process</option>
                  <option value={3}>On Hold</option>
                  <option value={4}>In QC</option>
                  <option value={5}>Sample Sent</option>
                  <option value={6}>In Revision</option>
                  <option value={7}>Cancelled</option>
                  <option value={8}>Completed</option>
                </select>
                <div className="mt-3">
                  <label className="form-label">Select Editor</label>
                  <select
                    className="form-select"
                    value={selectedEditor}
                    onChange={(e) => setSelectedEditor(e.target.value)}
                  >
                    <option value="">Select an editor</option>
                    {editors.map((ed) => (
                      <option key={ed._id} value={ed.fname}>
                        {ed.fname}
                      </option>
                    ))}
                  </select>
                </div>
                <label className="form-label mt-3">File Location</label>
                <input
                  type="text"
                  className="form-control"
                  value={fileLocation}
                  onChange={(e) => setFileLocation(e.target.value)}
                />

                <>
                  <label className="form-label mt-3">Message</label>
                  <input
                    type="text"
                    className="form-control"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                  />
                </>

                <button
                  onClick={updateWeddingAlbum}
                  className="btn text-light bg_maincolor mt-3"
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default WeddingAlbumDetailManager;
